import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  business_name: "Medical Therapy Group",
  logo_url: "",
  logo_full_url: "",
  brand_primary: "#0D9488",
  tagline: "Clinical Workspace",
  welcome_headline: "Clinical decision support & patient retention.",
  welcome_subtext:
    "Branded rehabilitation & posture plans, a Cliniko-driven retention engine, clinical notes and an evidence-cited Clinical Brain — built for practitioners, not patients.",
  welcome_footer: "Clinical Dashboard",
  keys_set: {},
};
const Ctx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  // Public branding endpoint — works before login so the welcome screen is branded too.
  const refresh = useCallback(
    () => api.get("/branding").then((r) => setSettings((s) => ({ ...DEFAULTS, ...s, ...r.data }))).catch(() => {}),
    []
  );
  useEffect(() => { refresh(); }, [refresh]);
  const value = useMemo(() => ({ settings, refresh, setSettings }), [settings, refresh]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx) || { settings: DEFAULTS, refresh: () => {} };
